import { defineMessages } from 'react-intl';

export default defineMessages({
  outOfStock: {
    id: 'collectionPDP.SizeSelection.outOfStock',
    defaultMessage: 'Out of Stock',
  },
});
